(function() {
  'use strict';

  var CONFIG = {
    baseCurrency: 'AED',
    defaultCurrency: 'AED',
    currencies: {
      'AED': { symbol: 'Dhs.', name: 'AED', flag: '🇦🇪' },
      'EUR': { symbol: '€', name: 'EUR', flag: '🇪🇺' },
      'USD': { symbol: '$', name: 'USD', flag: '🇺🇸' },
      'GBP': { symbol: '£', name: 'GBP', flag: '🇬🇧' },
      'TRY': { symbol: '₺', name: 'TRY', flag: '🇹🇷' },
      'CAD': { symbol: 'CA$', name: 'CAD', flag: '🇨🇦' },
      'AUD': { symbol: 'A$', name: 'AUD', flag: '🇦🇺' },
      'JPY': { symbol: '¥', name: 'JPY', flag: '🇯🇵' },
      'CHF': { symbol: 'CHF', name: 'CHF', flag: '🇨🇭' }
    },
    countryToCurrency: {
      'AE':'AED','AT':'EUR','BE':'EUR','BG':'EUR','HR':'EUR','CY':'EUR','CZ':'EUR',
      'DK':'EUR','EE':'EUR','FI':'EUR','FR':'EUR','DE':'EUR','GR':'EUR','HU':'EUR',
      'IE':'EUR','IT':'EUR','LV':'EUR','LT':'EUR','LU':'EUR','MT':'EUR','NL':'EUR',
      'PL':'EUR','PT':'EUR','RO':'EUR','SK':'EUR','SI':'EUR','ES':'EUR','SE':'EUR',
      'US':'USD','CA':'CAD','GB':'GBP','TR':'TRY','AU':'AUD','NZ':'AUD',
      'JP':'JPY','CH':'CHF','NO':'EUR','SG':'USD','HK':'USD','KR':'USD',
      'IL':'USD','MY':'USD'
    },
    cacheKey: 'eclotique_rates',
    cacheDuration: 6 * 60 * 60 * 1000,
    selectedKey: 'eclotique_currency'
  };

  var rates = null;
  var currentCurrency = CONFIG.defaultCurrency;

  function loadRates(callback) {
    var cached = localStorage.getItem(CONFIG.cacheKey);
    if (cached) {
      try {
        var data = JSON.parse(cached);
        if (Date.now() - data.timestamp < CONFIG.cacheDuration) {
          rates = data.rates;
          if (callback) callback();
          return;
        }
      } catch(e) {}
    }
    fetch('https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/aed.min.json')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data && data.aed) {
          rates = {};
          var r = data.aed;
          rates['AED'] = 1;
          rates['EUR'] = r['eur'] || 0.235;
          rates['USD'] = r['usd'] || 0.272;
          rates['GBP'] = r['gbp'] || 0.204;
          rates['TRY'] = r['try'] || 12.06;
          rates['CAD'] = r['cad'] || 0.374;
          rates['AUD'] = r['aud'] || 0.388;
          rates['JPY'] = r['jpy'] || 43.36;
          rates['CHF'] = r['chf'] || 0.215;
          localStorage.setItem(CONFIG.cacheKey, JSON.stringify({
            rates: rates,
            timestamp: Date.now()
          }));
        }
        if (callback) callback();
      })
      .catch(function() {
        rates = {'AED':1,'EUR':0.235,'USD':0.272,'GBP':0.204,'TRY':12.06,'CAD':0.374,'AUD':0.388,'JPY':43.36,'CHF':0.215};
        if (callback) callback();
      });
  }

  function detectCountry(callback) {
    var saved = localStorage.getItem(CONFIG.selectedKey);
    if (saved && CONFIG.currencies[saved]) {
      callback(saved);
      return;
    }
    fetch('https://ipapi.co/json/')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var cc = data.country_code || 'AE';
        var currency = CONFIG.countryToCurrency[cc] || 'AED';
        callback(currency);
      })
      .catch(function() {
        callback('AED');
      });
  }

  function parseAmount(text) {
    if (!text) return null;
    text = text.replace(/Dhs\./gi, '').replace(/AED/gi, '').replace(/From\s*/gi, '');
    text = text.replace(/[^\d.,]/g, '');
    text = text.replace(/^[.,]+/, '');
    if (!text) return null;
    var lastComma = text.lastIndexOf(',');
    var lastDot = text.lastIndexOf('.');
    if (lastComma > lastDot) {
      text = text.replace(/\./g, '').replace(',', '.');
    } else {
      text = text.replace(/,/g, '');
    }
    var num = parseFloat(text);
    return isNaN(num) ? null : num;
  }

  function formatMoney(amount, currency) {
    var c = CONFIG.currencies[currency];
    if (!c) return amount.toFixed(2);
    if (currency === 'JPY') {
      return c.symbol + ' ' + Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var parts = amount.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return c.symbol + ' ' + parts[0] + '.' + parts[1];
  }

  function convertPrice(aedAmount, toCurrency) {
    if (!rates || !rates[toCurrency]) return aedAmount;
    return aedAmount * rates[toCurrency];
  }

  function convertAllPrices() {
    if (!rates) return;
    var elements = document.querySelectorAll('.amount, .money');
    
    elements.forEach(function(el) {
      if (el.classList.contains('ecl-converting')) return;
      var original = el.getAttribute('data-ecl-original');
      if (!original) {
        original = el.textContent.trim();
        el.setAttribute('data-ecl-original', original);
      }
      if (currentCurrency === CONFIG.baseCurrency) {
        el.textContent = original;
        return;
      }
      var aedAmount = parseAmount(original);
      if (aedAmount === null || aedAmount === 0) return;
      var converted = convertPrice(aedAmount, currentCurrency);
      el.classList.add('ecl-converting');
      el.textContent = formatMoney(converted, currentCurrency);
      el.classList.remove('ecl-converting');
    });
  }

  function setCurrency(currency) {
    if (!CONFIG.currencies[currency]) return;
    currentCurrency = currency;
    localStorage.setItem(CONFIG.selectedKey, currency);
    convertAllPrices();
    updateSelector();
  }

  function updateSelector() {
    var selects = document.querySelectorAll('.ecl-currency-select');
    selects.forEach(function(s) { s.value = currentCurrency; });
  }

  function createSelector() {
    var containers = document.querySelectorAll('.thb-localization-forms');
    containers.forEach(function(container) {
      var existing = container.querySelector('.ecl-currency-wrapper');
      if (existing) return;
      
      var wrapper = document.createElement('div');
      wrapper.className = 'ecl-currency-wrapper select';
      
      var select = document.createElement('select');
      select.className = 'ecl-currency-select resize-select';
      select.setAttribute('aria-label', 'Currency');
      
      Object.keys(CONFIG.currencies).forEach(function(code) {
        var opt = document.createElement('option');
        opt.value = code;
        var c = CONFIG.currencies[code];
        opt.textContent = c.flag + ' ' + code + ' (' + c.symbol + ')';
        if (code === currentCurrency) opt.selected = true;
        select.appendChild(opt);
      });
      
      select.addEventListener('change', function() {
        setCurrency(this.value);
      });
      
      wrapper.appendChild(select);
      
      var nativeSelects = container.querySelectorAll('.thb-currency-code');
      nativeSelects.forEach(function(ns) {
        ns.closest('.select').style.display = 'none';
      });
      
      container.appendChild(wrapper);
    });

    if (containers.length === 0) {
      var header = document.querySelector('.thb-secondary-area');
      if (header) {
        var btn = document.createElement('div');
        btn.className = 'ecl-currency-floating';
        btn.innerHTML = '<button class="ecl-currency-display" aria-label="Change currency">' + CONFIG.currencies[currentCurrency].flag + ' ' + currentCurrency + '</button><div class="ecl-currency-dropdown ecl-hidden"></div>';
        
        var dropdown = btn.querySelector('.ecl-currency-dropdown');
        Object.keys(CONFIG.currencies).forEach(function(code) {
          var item = document.createElement('button');
          item.className = 'ecl-currency-item';
          var c = CONFIG.currencies[code];
          item.textContent = c.flag + ' ' + code + ' (' + c.symbol + ')';
          item.addEventListener('click', function() {
            setCurrency(code);
            dropdown.classList.add('ecl-hidden');
          });
          dropdown.appendChild(item);
        });
        
        btn.querySelector('.ecl-currency-display').addEventListener('click', function() {
          dropdown.classList.toggle('ecl-hidden');
        });
        
        header.insertBefore(btn, header.firstChild);
      }
    }
  }

  function observePriceChanges() {
    var debounce = null;
    var observer = new MutationObserver(function(mutations) {
      var shouldConvert = false;
      mutations.forEach(function(m) {
        if (m.type === 'childList' && m.addedNodes.length > 0) {
          for (var i = 0; i < m.addedNodes.length; i++) {
            var node = m.addedNodes[i];
            if (node.nodeType === 1 && !node.classList.contains('ecl-converting')) {
              if (node.querySelector && (node.querySelector('.amount') || node.querySelector('.money') || node.classList.contains('amount') || node.classList.contains('money'))) {
                shouldConvert = true;
                break;
              }
            }
          }
        }
      });
      if (shouldConvert && currentCurrency !== CONFIG.baseCurrency) {
        if (debounce) clearTimeout(debounce);
        debounce = setTimeout(convertAllPrices, 150);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    localStorage.removeItem(CONFIG.cacheKey);
    loadRates(function() {
      detectCountry(function(currency) {
        currentCurrency = currency;
        createSelector();
        convertAllPrices();
        updateSelector();
        observePriceChanges();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
